import {
  Box,
  Typography,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Trans } from '@gamiphy/react-i18n';

const Success: React.FC = () => (
  <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
    <Box borderRadius="50%" width="14.6rem" height="14.6rem" bgcolor="#04D1611A" display="flex" justifyContent="center" alignItems="center">
      <Box borderRadius="50%" width="10.5rem" height="10.5rem" bgcolor="#04D161" display="flex" justifyContent="center" alignItems="center">
        <CheckCircleIcon sx={{ fontSize: '3.8rem', color: '#fff' }} />
      </Box>
    </Box>
    <Typography fontSize="2.4rem" fontWeight={700} textAlign="center">
      <Trans
        i18nKey="user.welcome.success"
        defaults="Login Successful!"
      />
    </Typography>
    <Typography fontSize="1.6rem" color="#4F4F4F" textAlign="center">
      <Trans
        i18nKey="user.welcome.enjoy"
        defaults="Start enjoying exclusive discounts and exciting surprises!"
      />
    </Typography>
  </Box>
);

export default observer(Success);
